import type { Slide } from "@/lib/slides";
import type { SlideStyle } from "@/lib/slide-themes";

export const PRESENTER_LABEL = "presenter";
export const PRESENTER_EVENT = "sermonspace://present";
export const PRESENTER_READY = "sermonspace://present-ready";
export const PRESENTER_CONTROL = "sermonspace://present-control";

export interface PresenterState {
  slides: Slide[];
  index: number;
  blanked: boolean;
  style: SlideStyle;
}

export type PresenterControl = "next" | "prev" | "blank" | "close" | "home" | "end";
